import axios from 'axios'
export default {
	getEventos (ano, mes) {
		return new Promise((resolve, reject) => {
			axios.get('muro/php/lib/eventos/getEventos.php?ano=' + ano + '&mes=' + mes)
				.then(res => {
					const eventos = res.data.map(e => {
						const evento = {
							key: e.EventoID,
							dates: {
								start: new Date(e.FechaInicioUnix * 1000),
								end: new Date(e.FechaFinUnix * 1000)
							}
						}

						if (e.Titulo) {
							evento.popover = {}
							evento.popover.label = e.Titulo
						}

						if (e.Tipo === 'Punto') {
							evento.dot = e.Color
						} else if (e.Tipo === 'Linea') {
							evento.bar = e.Color
						} else {
							evento.highlight = {color: e.Color, fillMode: 'none'}
						}

						return evento
					})
					resolve(eventos)
				})
				.catch(e => {
					console.error(e)
					reject(e.response.data.error)
				})
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/muro/vue/servicios.js